import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"search\"><g class=\"is-icon-target\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m8 16c4.4183 0 8-3.5817 8-8 0-4.41828-3.5817-8-8-8-4.41828 0-8 3.58172-8 8 0 4.4183 3.58172 8 8 8z\" transform=\"translate(3 3)\" /><path d=\"m4.35 4.35-4.35000038-4.35000038\" transform=\"translate(16.65 16.65)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol